export default __webpack_public_path__ + "static/media/laser-pointer.54f18b6c.svg";